import { HttpHeaders, HttpParams } from '@angular/common/http';
import { AfterViewChecked, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CountryISO, PhoneNumberFormat, SearchCountryField } from 'ngx-intl-tel-input';
import { AirlineOffersScreenRequest } from 'src/app/model/request/airline-offers-screen-request';
import { ChangeDateTimeHeldBookingOrderCreateRequest } from 'src/app/model/request/change-date-time-order-create-request';
import {
  FareGroup,
  FareList,
  Flight,
  Offer as OfferOrderCreate,
  OfferItem as OfferItemOrderCreate,
  OfferItemIDAttributes as OfferItemIDAttributesOrderCreate,
  OfferPriceScreenOrderCreateRequest,
  OrderItem,
  OriginDestination,
  Party as OrderCreateParty,
  PostalAddress,
  SeatDescriptions,
  SeatSelection as SeatSelection
} from 'src/app/model/request/offer-price-screen-order-create-request';
import { Offer as ChangeBookingOffer, OfferItem as changeBookingOfferItem, OrderChangeChangeDatetimeRQ } from 'src/app/model/request/order-change-change-date-time-screen-request';
import { ContactInformation as orderChangeIssueTicketContactInformation, Offer as OfferOrderChange, OrderChangeIssueTicketRequest } from 'src/app/model/request/order-change-issue-ticket-request';
import { OrderChangeRequoteHeldBooking } from 'src/app/model/request/order-change-requote-held-booking';
import { AddAncilliariesScreen, OfferItem as addAncilliariesOfferItem } from 'src/app/model/screen/add-ancilliaries-screen';
import {
  Amount as confirmBookingAmount,
  AmountAttributes as confirmBookingAmountAttributes,
  CardDetail,
  CardHolderBillingAddress as confirmBookingCardHolderBillingAddress,
  Cash as confirmBookingCash,
  CashAttributes as confirmBookingCashAttributes,
  ConfirmBookingScreen,
  EffectiveExpireDate as confirmBookingEffectiveExpireDate,
  Method as confirmBookingMethod,
  Passenger as confirmBookingPassenger,
  Payer as confirmBookingPayer,
  Payment as confirmBookingPayment,
  PaymentCard as confirmBookingPaymentCard,
  Payments as confirmBookingPayments,
  ReshopPassenger,
  Surcharge as confirmBookingSurcharge
} from 'src/app/model/screen/confirm-booking-screen';
import { BoundAirlineOffer, FlightDetail, OfferItems, PassengerSelectedSeatDetail, SelectedBaggageDetail, SelectedSeatDetail } from 'src/app/model/screen/offer-price-screen';
import { Passenger as PassengerDetailSceenPassenger } from 'src/app/model/screen/passenger-detail-screen';
import { Booking, YourBookingScreen } from 'src/app/model/screen/your-booking-screen';
import { ApiService } from 'src/app/service/api.service';
import { CommonService } from 'src/app/service/common.service';
import { ContentfulService } from 'src/app/service/contentful.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import reQuoteTicketJSON from 'src/assets/json/order-change/request/requote-ticket-default-params.json';
import orderCreateJSON from 'src/assets/json/order-create/request/order-create-default-params.json';

@Component({
  selector: 'app-confirm-booking-screen',
  templateUrl: './confirm-booking-screen.component.html',
  styleUrls: ['./confirm-booking-screen.component.scss']
})
export class ConfirmBookingScreenComponent implements OnInit, AfterViewChecked {
  yourBookingScreenResponse: any;
  offerPriceScreebData: any;
  paymentDetails: any[] = [];
  submitted = false;

  public activeCardDetilIndex: any = 0;
  public cardNumberDetails: any[] = [];
  public selectedCardType: any = '';
  public selectedCardCode: any = '';
  public selectedCardNumber: any = '';
  public usedSegmentKey: any = [];
  isDisrupted: boolean = false;
  public selectedCardSurcharge: any = '0';
  haveOcnNotificationDetail: boolean = false;
  orderChangeIssueTicket: OrderChangeIssueTicketRequest = {} as OrderChangeIssueTicketRequest;
  orderChangeChangeDateTime: OrderChangeChangeDatetimeRQ = {} as OrderChangeChangeDatetimeRQ;
  orderChangeRequoteHeldBooking: OrderChangeRequoteHeldBooking = {} as OrderChangeRequoteHeldBooking;
  offerPriceScreenOrderCreateRequest: OfferPriceScreenOrderCreateRequest = {} as OfferPriceScreenOrderCreateRequest;
  changeDateTimeOrderCreateRequest: ChangeDateTimeHeldBookingOrderCreateRequest = {} as ChangeDateTimeHeldBookingOrderCreateRequest;
  passengerDetail: PassengerDetailSceenPassenger[] = [];
  reQuoteTicketInputParamsMap = new Map();
  orderCreateParamsMap = new Map();
  postalAddress: PostalAddress = {} as PostalAddress;

  confirmBookingScreenData = {} as ConfirmBookingScreen;
  confirmBookingFormType:
    | 'post-booking-requote-ticket-form'
    | 'post-booking-issue-ticket-form'
    | 'pre-booking-form'
    | 'post-booking-paid-sale-seat-form'
    | 'post-booking-free-sale-seat-form'
    | 'post-booking-add-paid-ancilliaries-service'
    | 'post-booking-add-free-ancilliaries-service'
    | 'post-booking-reshop'
    | 'post-booking-reshop-no-payment'
    | 'post-booking-reshop-hold' = 'pre-booking-form';

  cardDetails: CardDetail[] = [];
  cardTypeNames: any[] = [];
  cardNumbers: any[] = [];
  cardNumberList: any[] = [];
  public paymentForm: any = this.initPayment();

  priceDetails: any;

  public flightSegmentNumberIds: any = [];
  public flightDetails: any = [];
  public availableCards: any[] = [];

  public oldPrice: any;
  public newPrice: any;

  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  PhoneNumberFormat = PhoneNumberFormat;
  separateDialCode = true;
  isCardPaymentNotAllowed = false;
  isBookingHold = false;

  isSMEUser: boolean = false;
  countryCode: string = '';

  model1: any = {
    onColor: 'primary',
    offColor: 'secondary',
    onText: 'Passenger',
    offText: '3rd Party Payer',
    disabled: false,
    size: 'm'
  };

  model2: any = {
    onColor: 'primary',
    offColor: 'secondary',
    onText: 'Online',
    offText: 'Offline',
    disabled: false,
    size: 'm'
  };
  current_timestamp: any;
  selectedPNR: any;
  loggeduserMailID: any;

  get countries() {
    return this.commonService.getCountries();
  }

  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom, CountryISO.Spain, CountryISO.Germany, CountryISO.France, CountryISO.Russia];
  passengerDropDownList: any[] = [];
  invalidCardNames: any[] = [];
  public mappedSelectedOfferPriceFareCode: any = [];

  constructor(
    private commonService: CommonService,
    private sandboxPageStateService: SandboxPageStateService,
    private localAssetReaderService: LocalAssetReaderService,
    private xmlToJsonParserService: XmlToJsonParserService,
    private apiService: ApiService,
    private _fb: FormBuilder,
    private contentfulService: ContentfulService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    const query = { 'fields.name': 'Card Menu#SANDBOX' };
    this.contentfulService.getMenuContentWithItems(query).then((items) => {
      this.cardDetails = items[0]?.fields.jsonData;
      this.cardDetails.forEach((cardDetail: any) => {
        if (cardDetail.cardNumbersWithCategory.length === 0) {
          this.invalidCardNames.push(cardDetail.cardTypeName);
        }
      });
    });
    this.cardTypeNames = this.getCardTypeNames();
    Object.entries(reQuoteTicketJSON).forEach((entry) => {
      const [key, value] = entry;
      this.reQuoteTicketInputParamsMap.set(key, value);
    });
    Object.entries(orderCreateJSON).forEach((entry) => {
      const [key, value] = entry;
      this.orderCreateParamsMap.set(key, value);
    });
  }

  ngOnInit(): void {
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;

    let disrubtedOrderViewData = this.sandboxPageStateService.getYourBookingScreenData();
    this.initCurrencyCode();

    if (disrubtedOrderViewData.haveOcnNotificationDetail === true) {
      this.haveOcnNotificationDetail = disrubtedOrderViewData.haveOcnNotificationDetail;
      this.current_timestamp = disrubtedOrderViewData.current_timestamp;
      this.selectedPNR = disrubtedOrderViewData.pnrNumber;
    }

    this.mapConfirmBookingScreen();
  }

  initCurrencyCode(): void {
    this.offerPriceScreebData = this.sandboxPageStateService.getOfferPriceScreenData();
    const findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();

    const offerMetadata = this.getOfferPriceMetadata(this.offerPriceScreebData?.jsonData);
    const orderMetadata = this.getOrderReshopMetadata(findOrderScreenData?.reQuoteJson);

    const currencyCode = this.getCurrencyCode(offerMetadata) || this.getCurrencyCode(orderMetadata) || 'GBP';
    this.countryCode = currencyCode.slice(0, 2);
  }

  getOfferPriceMetadata(jsonData: any): any[] | undefined {
    const soapBody = jsonData?.['SOAP:ENVELOPE']?.['SOAP:BODY']?.[0];
    return soapBody?.OFFERPRICERS?.[0]?.METADATA?.[0]?.OTHER?.[0]?.OTHERMETADATA;
  }

  getOrderReshopMetadata(reQuoteJson: any): any[] | undefined {
    return reQuoteJson?.['SOAP:ENVELOPE']?.['SOAP:BODY']?.[0]
      ?.ORDERRESHOPRS?.[0]?.METADATA?.[0]?.OTHER?.[0]?.OTHERMETADATA;
  }

  getCurrencyCode(metadata: any[]|undefined): string | undefined {
    return metadata?.[2]?.CURRENCYMETADATAS?.[0]?.CURRENCYMETADATA?.[0]?.$?.METADATAKEY;
  }

  mapConfirmBookingScreen() {
    this.loggeduserMailID = this.sandboxPageStateService.getEncodedUserEmail();
    this.selectedPNR = this.sandboxPageStateService.getFindOrderFormValue();
    this.isSMEUser = this.sandboxPageStateService.getUser().isSMEUser;
    this.confirmBookingScreenData = this.sandboxPageStateService.getConfirmBookingScreenData();
    this.confirmBookingFormType = this.confirmBookingScreenData.bookingType;
    this.passengerDetail = this.sandboxPageStateService.getPassengerScreenDetail().passengerDetail;
    this.storePassengerInList();
    this.paymentDetails = [];
    this.offerPriceScreebData = this.sandboxPageStateService.getOfferPriceScreenData();
    let changeBookingScreenData = this.sandboxPageStateService.getChangeFlightDateTimeScreenData();
    if (changeBookingScreenData.bookingStatus === 'HOLD') {
      this.isBookingHold = true;
    }

    if (this.confirmBookingScreenData.bookingType === 'pre-booking-form') {
      if (this.offerPriceScreebData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].OFFERPRICERS[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS) {
      this.paymentDetails = this.offerPriceScreebData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].OFFERPRICERS[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
            let offerId = this.offerPriceScreebData.offerPrice.offerId;
      this.paymentDetails = this.paymentDetails.filter((item: any) => {
          const refs = item.$?.REFS; 
  if (typeof refs === 'string') {
      return refs.split(' ').includes(offerId);
    }
    return false;
});
      } else {
        this.isCardPaymentNotAllowed = true;
      }
    } else if (this.confirmBookingScreenData.bookingType === 'post-booking-issue-ticket-form') {
      let findOrderScreenData = this.sandboxPageStateService.getFindOrderScreenData();
      if (findOrderScreenData.reQuoteJson['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA) {
        this.paymentDetails =
          findOrderScreenData.reQuoteJson['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
        this.paymentDetails.forEach((item: any) => {
          let surcharge;
          let name = item.CARDNAME[0];
          let type = item.CARDTYPE[0];
          let cardName = `${name} - ${type}`;
          if (typeof item.SURCHARGE === 'undefined' || item.SURCHARGE === '') {
            surcharge = 0;
          } else {
            surcharge = item.SURCHARGE[0].AMOUNT[0]._;
          }
          this.availableCards.push({ name: cardName, surcharge: surcharge });
        });
      } else {
        this.isCardPaymentNotAllowed = true;
      }
    } else if (this.confirmBookingScreenData.bookingType === 'post-booking-paid-sale-seat-form') {
      let seatScreenData = this.sandboxPageStateService.getSeatSelectionScreenData();
      if (seatScreenData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].SEATAVAILABILITYRS[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA) {
        this.paymentDetails = seatScreenData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].SEATAVAILABILITYRS[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
        this.paymentDetails.forEach((item: any) => {
          let surcharge;
          let name = item.CARDNAME[0];
          let type = item.CARDTYPE[0];
          let cardName = `${name} - ${type}`; 
          if (typeof item.SURCHARGE === 'undefined' || item.SURCHARGE === '') {
            surcharge = 0;
          } else {
            surcharge = item.SURCHARGE[0].AMOUNT[0]._;
          }
          this.availableCards.push({ name: cardName, surcharge: surcharge });
        });
      } else {
        this.isCardPaymentNotAllowed = true;
      }
    } else if (this.confirmBookingScreenData.bookingType === 'post-booking-add-paid-ancilliaries-service') {
      let addBaggageScreenData = this.sandboxPageStateService.getAddBaggageScreenDetail();
      if (addBaggageScreenData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].SERVICELISTRS[0].METADATA[0].OTHER[0].OTHERMETADATA[1].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA) {
        this.paymentDetails = addBaggageScreenData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].SERVICELISTRS[0].METADATA[0].OTHER[0].OTHERMETADATA[1].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
        this.paymentDetails.forEach((item: any) => {
          let surcharge;
          let name = item.CARDNAME[0];
          let type= item.CARDTYPE[0];
          let cardName = `${name} - ${type}`; 
          if (typeof item.SURCHARGE === 'undefined' || item.SURCHARGE === '') {
            surcharge = 0;
          } else {
            surcharge = item.SURCHARGE[0].AMOUNT[0]._;
          }
          this.availableCards.push({ name: cardName, surcharge: surcharge });
        });
      } else {
        this.isCardPaymentNotAllowed = true;
      }
    } else if (this.confirmBookingScreenData.bookingType === 'post-booking-reshop') {
      let changedateTimeBookingData = this.sandboxPageStateService.getChangeBookingScreenData();
      if (
        changedateTimeBookingData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].METADATA[0].OTHER[0].OTHERMETADATA[1] &&
        changedateTimeBookingData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].METADATA[0].OTHER[0].OTHERMETADATA[1].PAYMENTCARDMETADATAS[0]
      ) {
        this.paymentDetails =
          changedateTimeBookingData.orderRepriceJSON['SOAP:ENVELOPE']['SOAP:BODY'][0].ORDERRESHOPRS[0].RESPONSE[0].METADATA[0].OTHER[0].OTHERMETADATA[1].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
        this.paymentDetails.forEach((item: any) => {
          let surcharge;
          let name = item.CARDNAME[0]; 
          let type= item.CARDTYPE[0];
          let cardName = `${name} - ${type}`;      
          if (typeof item.SURCHARGE === 'undefined' || item.SURCHARGE === '') {
            surcharge = 0;
          } else {
            surcharge = item.SURCHARGE[0].AMOUNT[0]._;
          }
          this.availableCards.push({ name: cardName, surcharge: surcharge });
        });
      } else {
        this.isCardPaymentNotAllowed = true;
      }
    }
    
    if (this.confirmBookingScreenData.bookingType === 'pre-booking-form') {     
      this.paymentDetails = this.offerPriceScreebData.jsonData['SOAP:ENVELOPE']['SOAP:BODY'][0].OFFERPRICERS[0].METADATA[0].OTHER[0].OTHERMETADATA[0].PAYMENTCARDMETADATAS[0].PAYMENTCARDMETADATA;
      let offerId = this.offerPriceScreebData.offerPrice.offerId;
      this.paymentDetails = this.paymentDetails.filter((item: any) => {
  
        const refs = item.$?.REFS;
        if (typeof refs === 'string') {
      return refs.split(' ').includes(offerId);
    }
    return false;
});
      this.paymentDetails.forEach((item: any) => {
        let surcharge;
        let name = item.CARDNAME[0];
        let type= item.CARDTYPE[0];
        let cardName = `${name} - ${type}`;      

        if (typeof item.SURCHARGE === 'undefined' || item.SURCHARGE === '') {
          surcharge = 0;
        } else {
          surcharge = item.SURCHARGE[0].AMOUNT[0]._;
        }
        this.availableCards.push({ name: cardName, surcharge: surcharge });
      });

      const paymentDetailsMap = new Map();

      this.paymentDetails.forEach((paymentDetail) => {
        if (!paymentDetailsMap.has(paymentDetail.CARDNAME[0])) {
          paymentDetailsMap.set(paymentDetail.CARDNAME[0], paymentDetail);
        }
      });
    }
    //this.paymentDetails = Array.from(paymentDetailsMap.values());
    this.removeInvalidCards();
    this.cardExpiryDetails();
  }

  removeInvalidCards() {
    setTimeout(() => {
      this.availableCards = this.availableCards.filter((availableCard: any) => {
        return this.invalidCardNames.indexOf(availableCard.name) === -1;
      });
    }, 1000);
  }
  storePassengerInList() {
    this.passengerDetail = this.sandboxPageStateService.getPassengerScreenDetail().passengerDetail;
    this.passengerDropDownList = [];
    let passengerIndex = 0;
    this.passengerDetail.forEach((passenger: PassengerDetailSceenPassenger) => {
      this.passengerDropDownList.push({
        value: passengerIndex,
        text: passenger.passengerName + ' ' + passenger.passengerSurName
      });
      passengerIndex++;
    });
  }

  getCardTypeNames() {
    let cardTypeNames = this.cardDetails.map((cardDetail) => cardDetail.cardTypeName);
    return cardTypeNames;
  }

  getCardNumbers(availableCardIndex: any) {
    let selectedCardDetail: any = this.availableCards[availableCardIndex];
    let cardTypeName = selectedCardDetail.name;
    let cardDetail = this.cardDetails.find((cardDetail) => cardDetail.cardTypeName === cardTypeName);
    let cardNumbers: string[] = cardDetail?.cardNumbersWithCategory.map((cardNumberWithCategory) => cardNumberWithCategory.cardNumber) || [];
    //this.paymentForm.controls.cardDetail.controls['cardNumber'].setValue(cardNumbers[0]);
    this.cardNumberList = cardNumbers;
    // return cardNumbers;
  }

  isPaymentModeSelected() {
    return ['CASH', 'CARD', 'HOLD'].includes(this.inp_group('paymentType').value);
  }

  initPayment() {
    let currency: any = '';
    let totalPrice: any = 0;
    let flightCharge: any = 0;
    let seatCharge: any = 0;
    let bagPrice: any = 0;
    let paymentType = '';
    let confirmBookingScreenData = this.sandboxPageStateService.getConfirmBookingScreenData();
    let bookingFormType = confirmBookingScreenData.bookingType;
    let firstNameValidators = [Validators.required];
    let lastNameValidators = [Validators.required];
    if (bookingFormType === 'post-booking-issue-ticket-form') {
      totalPrice = confirmBookingScreenData.heldBookingIssueTicketDetails.priceDetails.totalCharge;
      currency = confirmBookingScreenData.heldBookingIssueTicketDetails.priceDetails.priceCode;
      flightCharge = confirmBookingScreenData.heldBookingIssueTicketDetails.priceDetails.flightPrice;
      seatCharge = confirmBookingScreenData.heldBookingIssueTicketDetails.priceDetails.seatPrice;
    } else if (bookingFormType === 'pre-booking-form') {
      totalPrice = confirmBookingScreenData.primeBookingTicketDetail.priceDetails.totalCharge;
      bagPrice = confirmBookingScreenData.primeBookingTicketDetail.priceDetails.bagPrice;
      currency = confirmBookingScreenData.primeBookingTicketDetail.priceDetails.priceCode;
      flightCharge = confirmBookingScreenData.primeBookingTicketDetail.priceDetails.flightPrice;
      seatCharge = confirmBookingScreenData.primeBookingTicketDetail.priceDetails.seatPrice;
    } else if (
      bookingFormType === 'post-booking-requote-ticket-form' ||
      bookingFormType === 'post-booking-add-free-ancilliaries-service' ||
      bookingFormType === 'post-booking-free-sale-seat-form' ||
      bookingFormType === 'post-booking-reshop-hold' ||
      bookingFormType === 'post-booking-reshop-no-payment'
    ) {
      paymentType = 'HOLD';
      firstNameValidators = [];
      lastNameValidators = [];
    } else if (bookingFormType === 'post-booking-paid-sale-seat-form') {
      seatCharge = confirmBookingScreenData.postSeatSaleTicketDetail.priceDetails.seatPrice;
      totalPrice = confirmBookingScreenData.postSeatSaleTicketDetail.priceDetails.totalCharge;
      currency = confirmBookingScreenData.postSeatSaleTicketDetail.priceDetails.priceCode;
    } else if (bookingFormType === 'post-booking-add-paid-ancilliaries-service') {
      totalPrice = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.totalCharge;
      let selectedBagPrice = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.bagPrice;
      let selectedMealPrice = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.mealPrice;
      let selectedCarbPrice = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.carbPrice;
      let selectedDisablityServicePrice = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.disablityAssistancePrice;
      bagPrice = selectedBagPrice + selectedMealPrice + selectedDisablityServicePrice + selectedCarbPrice;

      currency = confirmBookingScreenData.postBookingAncilliariesDetail.priceDetails.priceCode;
    } else if (bookingFormType === 'post-booking-reshop') {
      totalPrice = confirmBookingScreenData.postBookingChangeDateTimeBookingDetail.priceDetails.totalCharge;
      currency = confirmBookingScreenData.postBookingChangeDateTimeBookingDetail.priceDetails.priceCode;
      flightCharge = confirmBookingScreenData.postBookingChangeDateTimeBookingDetail.priceDetails.flightPrice;
    }
    seatCharge = parseFloat(seatCharge).toFixed(2);
    flightCharge = parseFloat(flightCharge).toFixed(2);
    bagPrice = parseFloat(bagPrice).toFixed(2);
    totalPrice = parseFloat(totalPrice).toFixed(2);

    this.priceDetails = {};
    this.priceDetails = {
      flightCharge: flightCharge,
      bagPrice: bagPrice,
      seatCharge: seatCharge,
      totalPrice: totalPrice,
      currency: currency
    };

    return this._fb.group({
      paymentType: [paymentType],
      customerDetail: this._fb.group({
        firstName: [''],
        lastName: [''],
        user: ['0'],
        customerType: [false],
        address1: ['ADDRESS1'],
        address2: ['ADDRESS2'],
        city: ['CITY'],
        state: ['STATE'],
        zipCode: ['ZIP'],
        country: ['', [Validators.required]]
      }),
      contactDetails: this._fb.group({
        email: ['ndc@ba.com'],
        phone: ['447920765432'],
        phoneCode: ['44']
      }),
      cardDetail: this._fb.group({
        cardType: [''],
        cardNumber: [''],
        validMM: [''],
        validYY: [''],
        cv: [],
        paymentMode: [false]
      }),
      voucherDetail: this._fb.group({
        voucherCode: [''],
        voucherAmount: ['']
      }),
      priceDetail: this._fb.group({
        flightPrice: [flightCharge],
        seatPrice: [seatCharge],
        servicePrice: [bagPrice],
        cardFee: ['0'],
        totalCharge: [totalPrice],
        currency: [currency]
      })
    });
  }

  inp_control(controlName: string) {
    return this.paymentForm.controls[controlName];
  }
  inp_group(controlName: string) {
    return this.inp_control(controlName) as FormGroup;
  }
  inp_group_control(groupName: string, controlName: string) {
    return this.inp_group(groupName).controls[controlName];
  }
  upPaymentType(id: 'CASH' | 'CARD' | 'HOLD') {
    this.paymentForm.patchValue({
      paymentType: id
    });
    this.onPaymentTypeChange(id);
  }

  roundConfirmBookingPrice(value: string): string {
    let priceData = parseFloat(value);
    return priceData.toFixed(2);
  }
//   roundConfirmBookingPrice(value: number | string): string {
//     const priceData = typeof value === 'string' ? parseFloat(value) : value;
//     return priceData.toFixed(2);
// }
  cardExpiryDetails() {
    var today = new Date();
    var month = today.toLocaleString('default', { month: '2-digit' });
    let currentMonth = month;
    let year = new Date().getFullYear().toString().slice(-2);

    let expYear = parseInt(year) + 2;

    this.paymentForm.controls.cardDetail.controls.validMM.setValue(currentMonth);
    this.paymentForm.controls.cardDetail.controls.validYY.setValue(expYear);
    this.paymentForm.controls.cardDetail.controls.cv.setValue('777');
    this.paymentForm.controls.customerDetail.controls.country.setValue('United Kingdom');
  }
  setCardValidation() {
    const firstName = this.paymentForm.get('customerDetail.firstName');
    const lastName = this.paymentForm.get('customerDetail.lastName');
    let paymentType = this.inp_group('paymentType').value;
    let addValidationToFirstLastName: boolean = false;
    if (paymentType === 'CARD') {
      let payerType = this.inp_group_control('customerDetail', 'customerType').value;
      if (!payerType) {
        addValidationToFirstLastName = true;
      }
    }
    if (addValidationToFirstLastName) {
      firstName.setValidators([Validators.required]);
      lastName.setValidators([Validators.required]);
    } else {
      firstName.clearValidators();
      lastName.clearValidators();
    }
    firstName.updateValueAndValidity();
    lastName.updateValueAndValidity();
  }
  onPaymentTypeChange(type: string) {
    const cardType = this.paymentForm.get('cardDetail.cardType');
    const cardNumber = this.paymentForm.get('cardDetail.cardNumber');
    const validMM = this.paymentForm.get('cardDetail.validMM');
    const validYY = this.paymentForm.get('cardDetail.validYY');
    const cv = this.paymentForm.get('cardDetail.cv');
    this.paymentForm.get('customerDetail.address1').setValidators([Validators.required]);
    this.paymentForm.get('customerDetail.city').setValidators([Validators.required]);
    this.paymentForm.get('customerDetail.zipCode').setValidators([Validators.required]);
    this.paymentForm.get('customerDetail.country').setValidators([Validators.required]);
    this.paymentForm.get('contactDetails.email').setValidators([Validators.required, Validators.email]);
    this.paymentForm.get('contactDetails.phone').setValidators([Validators.required]);
    this.submitted = false;
    if (type == 'CARD') {
      this.paymentForm.get('cardDetail').enable();
      this.paymentForm.get('customerDetail').enable();
      cardType.setValidators([Validators.required]);
      cardNumber.setValidators([Validators.required]);
      validMM.setValidators([Validators.required]);
      validYY.setValidators([Validators.required]);
      cv.setValidators([Validators.required]);
    } else {
      this.paymentForm.get('contactDetails').enable();
      this.paymentForm.get('customerDetail').disable();
      this.paymentForm.get('customerDetail').clearValidators();
      this.paymentForm.get('customerDetail').updateValueAndValidity();
      this.paymentForm.get('cardDetail').disable();
      this.paymentForm.get('cardDetail').clearValidators();
      this.paymentForm.get('cardDetail').updateValueAndValidity();
    }
    cardType.updateValueAndValidity();
    cardNumber.updateValueAndValidity();
    validMM.updateValueAndValidity();
    validYY.updateValueAndValidity();
    cv.updateValueAndValidity();
    this.setCardValidation();
  }
  onPayerClick() {
    const type = this.inp_group_control('customerDetail', 'customerType').value;
    this.paymentForm.patchValue({
      customerDetail: {
        customerType: type === true ? false : true
      }
    });
  }
  onCustomerValueChange(event: any) {
    this.setCardValidation();
    this.storePassengerInList();
  }
  saveBooking() {
    this.submitted = true;
    if (this.inp_group('paymentType').value === '' || !this.paymentForm.valid || this.paymentForm.get('customerDetail').controls.country.value === '0') {
      return;
    } else {
      this.reQuoteTicketInputParamsMap.set('##TravelAgencySender##Type##', 'Offline');
      this.orderCreateParamsMap.set('##TravelAgencySender##Type##', 'Offline');
      const paymentMode = this.inp_group_control('cardDetail', 'paymentMode').value;
      if (this.inp_group('paymentType').value === 'CARD') {
        if (paymentMode) {
          this.reQuoteTicketInputParamsMap.set('##TravelAgencySender##Type##', 'Online');
          this.orderCreateParamsMap.set('##TravelAgencySender##Type##', 'Online');
        }
      }
      if (
        (this.inp_group('paymentType').value === 'CARD' && this.paymentForm.get('cardDetail').valid) ||
        (this.inp_group('paymentType').value !== 'CARD' && (this.paymentForm.get('customerDetail').valid || this.paymentForm.get('contactDetails').valid))
      ) {
        if (this.inp_group('paymentType').value === 'CARD') {
          this.storeSelectedCardDetail(); 
        }
        if (this.confirmBookingFormType === 'post-booking-requote-ticket-form') {
          this.initReQuoteHeldBookingRequest();
        } else if (this.confirmBookingFormType === 'post-booking-issue-ticket-form') {
          this.initIssueTicketBookingRequest();
        } else if (this.confirmBookingFormType === 'pre-booking-form') {
          this.initOfferPriceScreenPrimeOrderCreateBooking();
        } else if (this.confirmBookingFormType === 'post-booking-paid-sale-seat-form') {
          this.initPostSeatSaleOrderChangeBooking();
        } else if (this.confirmBookingFormType === 'post-booking-free-sale-seat-form') {
          this.initPostSeatFreeSaleOrderChangeBooking();
        } else if (this.confirmBookingFormType === 'post-booking-add-free-ancilliaries-service') {
          this.initPostAddFreeAncilliariesOrderChangeBooking();
        } else if (this.confirmBookingFormType === 'post-booking-add-paid-ancilliaries-service') {
          this.initPostAddPaidAncilliariesOrderChangeBooking();
        } else if (
          this.confirmBookingFormType === 'post-booking-reshop' ||
          this.confirmBookingFormType === 'post-booking-reshop-hold' ||
          this.confirmBookingFormType === 'post-booking-reshop-no-payment'
        ) {
          this.initChangeDateTimeOrderChangeBooking();
        }
      }
    }
  }
  async initPostAddFreeAncilliariesOrderChangeBooking() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let owner = bookingDetail?.bookingAgent;

    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let selectedOfferItem = addAncilliariesScreenData.selectedOfferItem;
    // let longSellSelectedOfferItem = this.offerPriceScreebData.selectedOfferItem;

    let selectedOfferItemLength = selectedOfferItem.length;
    if (selectedOfferItemLength > 0) {
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
      this.orderChangeIssueTicket = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
        PassengerList: {
          Passenger: this.loadPassengerBasicRequestXMLDetailDetail()
        }
      };
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        AcceptOffer: {
          Offer: this.loadPostSaleAddAncilliariesOffer()
        }
      };
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      //this.loadPassengerDetail();
      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeIssueTicket), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updateAddAncilliariesXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }
  updateAddAncilliariesXMLResponse(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.isMapped = false;
      yourBookingScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreenData.xml!);
      yourBookingScreenData.displayConfirmBookingForm = false;
      if (yourBookingScreenData.bookingType === 'post-booking-reshop') {
        yourBookingScreenData.bookingType = 'post-booking-reshop';
      }
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      let addAnclilliariesScreenData = {} as AddAncilliariesScreen;
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);

      patchSandboxSourceData = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }

      this.triggerOcnMessage('ACTIONED');

      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      setTimeout(() => {
        let patchSandboxSourceData: any = '';
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }

  triggerOcnMessage(status: 'ACTIONED' | 'CANCELLED') {
    let yourBookingData = this.sandboxPageStateService.getYourBookingScreenData();
    if (this.haveOcnNotificationDetail) {
      //this.initOCNMessageAPIRequest(findOrderScreenData.pnr,status);
      this.postUserInformation(status);
      // trigger api
      //trigger success
      yourBookingData.haveOcnNotificationDetail = false;
      this.sandboxPageStateService.updateFindOrderScreen(yourBookingData);
      this.haveOcnNotificationDetail = false;
      //trigger success end
      //trgger end
    }
  }

  async postUserInformation(status: 'ACTIONED' | 'CANCELLED') {
    let queryParams = new HttpParams();
    let body = [
      {
        pnr: this.selectedPNR,
        currentTimestamp: this.current_timestamp,
        changedBy: this.loggeduserMailID,
        userAction: 'Changed-Date-Time'
      }
    ];
    await this.apiService.sendPostRequest(body, '/update-ocn-messages');
  }

  async initPostAddPaidAncilliariesOrderChangeBooking() {
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let bookingDetail = yourBookingScreenDetail.booking;
      let pnr = bookingDetail?.pnrNumber;
      let owner = bookingDetail?.bookingAgent;
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
      this.orderChangeIssueTicket = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
        PassengerList: {
          Passenger: []
        },
        ContactList: {
          ContactInformation: []
        }
      };
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        AcceptOffer: {
          Offer: this.loadPostSaleAddAncilliariesOffer()
        }
      };
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;

      let paymnetCode: any = '';
      let customerType = this.inp_group_control('customerDetail', 'customerType').value;
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      if (paymentType === 'CASH') {
        paymnetCode = 'CA';
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash = {} as confirmBookingCash;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash.$ = {} as confirmBookingCashAttributes;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount = {} as confirmBookingAmount;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount.$ = {} as confirmBookingAmountAttributes;

        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCashBookingPaymentDetail();
      } else if (paymentType === 'CARD') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard = {} as confirmBookingPaymentCard;
        if (!customerType) {
          this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Payer = {} as confirmBookingPayer;
        }
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.CardHolderBillingAddress = {} as confirmBookingCardHolderBillingAddress;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.EffectiveExpireDate = {} as confirmBookingEffectiveExpireDate;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.Surcharge = {} as confirmBookingSurcharge;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCardBookingPaymentDetail();
      }

      this.loadPassengerDetail();
      if (paymentType === 'CASH') {
        this.loadContactDetail('CASH');
      } else if (paymentType === 'CARD') {
        this.loadContactDetail('CARD');
      }

      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeIssueTicket), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updateAddAncilliariesXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }
  async initChangeDateTimeOrderChangeBooking() {
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let changeBookingScreenData = this.sandboxPageStateService.getChangeFlightDateTimeScreenData();
      let bookingDetail = yourBookingScreenDetail.booking;
      let pnr = bookingDetail?.pnrNumber;
      let owner = bookingDetail?.bookingAgent;
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_CHANGE_DATE_TIME_BOOKING_REQUEST_TEMPLATE);
      this.orderChangeChangeDateTime = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeChangeDateTime['S:Envelope'].$!['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeChangeDateTime['S:Envelope'].$!['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeChangeDateTime['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.PointOfSale = '';
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      //this.mapOrderItemsForDelete();
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing.Delete.OrderItemID = changeBookingScreenData.seatOfferIdList;
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing.AcceptOffer.Offer = {
        $: {
          OfferID: changeBookingScreenData.selectedOfferItem.offerId,
          Owner: changeBookingScreenData.selectedOfferItem.offerOwner,
          ResponseID: changeBookingScreenData.responseID
        },
        OfferItem: this.getOfferItems()
      };
      let paymnetCode: any = '';
      let customerType = this.inp_group_control('customerDetail', 'customerType').value;
      delete this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      if (!this.isBookingHold && this.confirmBookingFormType !== 'post-booking-reshop-no-payment') {
        if (paymentType === 'CASH') {
          paymnetCode = 'CA';
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash = {} as confirmBookingCash;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash.$ = {} as confirmBookingCashAttributes;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount = {} as confirmBookingAmount;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount.$ = {} as confirmBookingAmountAttributes;

          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCashBookingPaymentDetail();
        } else if (paymentType === 'CARD') {
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard = {} as confirmBookingPaymentCard;
          if (!customerType) {
            this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Payer = {} as confirmBookingPayer;
          }
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.CardHolderBillingAddress = {} as confirmBookingCardHolderBillingAddress;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.EffectiveExpireDate = {} as confirmBookingEffectiveExpireDate;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.Surcharge = {} as confirmBookingSurcharge;
          this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCardBookingPaymentDetail();
        }
      }
      this.loadReshopPassengerDetail(paymentType);

      if (paymentType === 'CASH') {
        this.loadContactDetail('CASH');
      } else if (paymentType === 'CARD') {
        this.loadContactDetail('CARD');
      }
      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeChangeDateTime), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updateAddAncilliariesXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }

  getOfferItems() {
    let changeBookingScreenData = this.sandboxPageStateService.getChangeFlightDateTimeScreenData();
    let changeBookingRepriceOffers = changeBookingScreenData.selectedOfferItem.offerItem;
    let offers: changeBookingOfferItem[] = [];
    if (changeBookingRepriceOffers.length > 0) {
      changeBookingRepriceOffers.forEach((offer: any) => {
        let offerItem = {
          $: {
            OfferItemID: offer.offerItemID
          },
          PassengerRefs: offer.passengerRefs
        };
        offers.push(offerItem);
      });
    }
    return offers;
  }

  getReshopOfferItems() {
    let changeBookingScreenData = this.sandboxPageStateService.getChangeFlightDateTimeScreenData();
    let changeBookingRepriceOffers = changeBookingScreenData.selectedOfferItem.offerItem;
    let offers: changeBookingOfferItem[] = [];
    if (changeBookingRepriceOffers.length > 0) {
      changeBookingRepriceOffers.forEach((offer: any) => {
        let offerItem = {
          $: {
            OfferItemID: offer.offerItemID
          },
          PassengerRefs: offer.passengerRefs
        };
        offers.push(offerItem);
      });
    }
    return offers;
  }
  loadPostSaleAddAncilliariesOffer() {
    let addAncilliariesScreenData = this.sandboxPageStateService.getAddAncilliariesScreenData();
    let selectedOfferItem = addAncilliariesScreenData.selectedOfferItem;
    let selectedOfferItemLength = selectedOfferItem.length;
    let seatOfferLists: OfferOrderChange[] = [];
    if (selectedOfferItemLength > 0) {
      let seatOffer: OfferOrderChange = {
        $: {
          OfferID: addAncilliariesScreenData.selectedOfferId,
          Owner: addAncilliariesScreenData.selectedOwner,
          ResponseID: addAncilliariesScreenData.selectedResponseId
        },
        OfferItem: this.loadServiceOfferItem(selectedOfferItem)
      };
      seatOfferLists.push(seatOffer);
    }
    return seatOfferLists;
  }
  loadChangeDateTimeOffer(): ChangeBookingOffer {
    let changeDateTimeDate = this.sandboxPageStateService.getChangeBookingScreenData();
    let selectedOfferItem = changeDateTimeDate.selectedOfferItem;
    let selectedOfferItemLength = selectedOfferItem.offerItem.length;
    let offerItems: changeBookingOfferItem[] = [];

    selectedOfferItem.offerItem.forEach((item: any) => {
      let offerItem = {} as changeBookingOfferItem;
      offerItem.$ = {} as OfferItemIDAttributesOrderCreate;
      offerItem.$.OfferItemID = item.offerItemID;
      offerItem.PassengerRefs = item.passengerId;
      offerItems.push(offerItem);
    });
    let changeBookingOffer: ChangeBookingOffer = {
      $: {
        OfferID: selectedOfferItem.offerId,
        Owner: selectedOfferItem.offerOwner,
        ResponseID: changeDateTimeDate.responseID
      },
      OfferItem: offerItems
    };

    return changeBookingOffer;
  }
  loadServiceOfferItem(selectedOfferItem: addAncilliariesOfferItem[]) {
    let offerItems: OfferItemOrderCreate[] = [];
    selectedOfferItem.forEach((seat: addAncilliariesOfferItem) => {
      let offerItem = {} as OfferItemOrderCreate;
      offerItem.$ = {} as OfferItemIDAttributesOrderCreate;
      offerItem.$.OfferItemID = seat.offerItemID;
      offerItem.PassengerRefs = seat.passengerId;
      offerItems.push(offerItem);
    });
    return offerItems;
  }
  async initPostSeatFreeSaleOrderChangeBooking() {
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let bookingDetail = yourBookingScreenDetail.booking;
      let pnr = bookingDetail?.pnrNumber;
      let owner = bookingDetail?.bookingAgent;
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
      this.orderChangeIssueTicket = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
        PassengerList: {
          Passenger: this.loadPassengerBasicRequestXMLDetailDetail()
        }
      };
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        AcceptOffer: {
          Offer: this.postSaleSeatOffer()
        }
      };
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      //this.loadPassengerDetail();
      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeIssueTicket), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updatePostSaleSeatTicketXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }
  async initPostSeatSaleOrderChangeBooking() {
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let bookingDetail = yourBookingScreenDetail.booking;
      let pnr = bookingDetail?.pnrNumber;
      let owner = bookingDetail?.bookingAgent;
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
      this.orderChangeIssueTicket = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
        PassengerList: {
          Passenger: []
        },
        ContactList: {
          ContactInformation: []
        }
      };
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderServicing = {
        AcceptOffer: {
          Offer: this.postSaleSeatOffer()
        }
      };
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;

      let paymnetCode: any = '';
      let customerType = this.inp_group_control('customerDetail', 'customerType').value;
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      if (paymentType === 'CASH') {
        paymnetCode = 'CA';
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash = {} as confirmBookingCash;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash.$ = {} as confirmBookingCashAttributes;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount = {} as confirmBookingAmount;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount.$ = {} as confirmBookingAmountAttributes;

        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCashBookingPaymentDetail();
      } else if (paymentType === 'CARD') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard = {} as confirmBookingPaymentCard;
        if (!customerType) {
          this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Payer = {} as confirmBookingPayer;
        }
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.CardHolderBillingAddress = {} as confirmBookingCardHolderBillingAddress;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.EffectiveExpireDate = {} as confirmBookingEffectiveExpireDate;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.Surcharge = {} as confirmBookingSurcharge;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCardBookingPaymentDetail();
      }

      this.loadPassengerDetail();
      if (paymentType === 'CASH') {
        this.loadContactDetail('CASH');
      } else if (paymentType === 'CARD') {
        this.loadContactDetail('CARD');
      }

      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeIssueTicket), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updatePostSaleSeatTicketXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }

  postSaleSeatOffer() {
    let yourBookingScreen = this.sandboxPageStateService.getYourBookingScreenData();
    let selectedSeatsOffer = yourBookingScreen.selectedSeatItem;
    let seatOfferLists: OfferOrderChange[] = [];
    if (selectedSeatsOffer.length > 0) {
      selectedSeatsOffer.forEach((seatOffers: PassengerSelectedSeatDetail) => {
        let seatOffer: OfferOrderChange = {
          $: {
            OfferID: seatOffers.offerId,
            Owner: seatOffers.owner,
            ResponseID: seatOffers.responseId
          },
          OfferItem: this.loadSeatOfferPrice(seatOffers.offerDetail)
        };
        seatOfferLists.push(seatOffer);
        //this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.Offer?.push(seatOffer);
      });
    }
    return seatOfferLists;
  }

  updatePostSaleSeatTicketXML(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.isMapped = false;
      yourBookingScreenData.selectedSeatItem = [];
      yourBookingScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreenData.xml!);
      yourBookingScreenData.displayConfirmBookingForm = false;
      yourBookingScreenData.displayCancelGetRefundForm = false;
      yourBookingScreenData.booking = {} as Booking;

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      patchSandboxSourceData = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      setTimeout(() => {
        let patchSandboxSourceData: any = '';
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }

  async initIssueTicketBookingRequest() {
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
      let bookingDetail = yourBookingScreenDetail.booking;
      let pnr = bookingDetail?.pnrNumber;
      let owner = bookingDetail?.bookingAgent;
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_ISSUE_TICKET_REQUEST_TEMPLATE);
      this.orderChangeIssueTicket = JSON.parse(jsonRequestTemplate as any);
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.orderChangeIssueTicket['S:Envelope']['SOAP-ENV:Header'] = '';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
        PassengerList: {
          Passenger: []
        },
        ContactList: {
          ContactInformation: []
        }
      };
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID = pnr;
      // delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder;
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder = {
        ResponseID: this.confirmBookingScreenData.heldBookingIssueTicketDetails?.ResponseID
      };
      let paymnetCode: any = '';
      let customerType = this.inp_group_control('customerDetail', 'customerType').value;
      delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments;
      if (paymentType === 'CASH') {
        paymnetCode = 'CA';
        // .Payment.Method.PaymentCard;
        // delete this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.Query.Payments.Payment.Payer;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash = {} as confirmBookingCash;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.Cash.$ = {} as confirmBookingCashAttributes;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount = {} as confirmBookingAmount;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Amount.$ = {} as confirmBookingAmountAttributes;

        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCashBookingPaymentDetail();
      } else if (paymentType === 'CARD') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments = {} as confirmBookingPayments;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard = {} as confirmBookingPaymentCard;
        if (!customerType) {
          this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Payer = {} as confirmBookingPayer;
        }
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.CardHolderBillingAddress = {} as confirmBookingCardHolderBillingAddress;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.EffectiveExpireDate = {} as confirmBookingEffectiveExpireDate;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment.Method.PaymentCard.Surcharge = {} as confirmBookingSurcharge;
        this.orderChangeIssueTicket['S:Envelope']['S:Body']!.OrderChangeRQ.Query.Payments.Payment = this.getCardBookingPaymentDetail();
      }

      this.loadPassengerDetail();
      if (paymentType === 'CASH') {
        this.loadContactDetail('CASH');
      } else if (paymentType === 'CARD') {
        this.loadContactDetail('CARD');
      }

      await this.apiService.getXMLResponse(this.sandboxPageStateService.ORDER_CHANGE_URL, JSON.stringify(this.orderChangeIssueTicket), this.reQuoteTicketInputParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderChange17_2_V4'
        }),
        responseType: 'text'
      });
      this.updateIssueTicketXML(this.sandboxPageStateService.ORDER_CHANGE_URL);
    }
  }
  updateIssueTicketXML(url: any) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.isMapped = false;
      yourBookingScreenData.selectedSeatItem = [];
      yourBookingScreenData.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreenData.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreenData.xml!);
      yourBookingScreenData.displayConfirmBookingForm = false;
      yourBookingScreenData.booking = {} as Booking;

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        if (typeof patchSandboxSourceData === 'object' && patchSandboxSourceData !== null) {
          patchSandboxSourceData['showWarning'] = 'Yes';
          patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
        }
      }

      patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'issue-ticket-success-response' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  loadContactDetail(paymentType: any) {
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let customerDetail = this.inp_control('customerDetail').value;
    let contactDetail = this.inp_control('contactDetails').value;
    let contactInformationList: orderChangeIssueTicketContactInformation[] = [];

    let selectedPasengerIndex = 0;
    let customerType = this.inp_group_control('customerDetail', 'customerType').value;
    if (customerType) {
      selectedPasengerIndex = customerDetail.user;
    }
    let contactInformation: orderChangeIssueTicketContactInformation = {
      $: {
        ContactID: 'contact-' + passengerDetail[selectedPasengerIndex].passengerId
      },
      ContactType: 'Payment',
      PostalAddress: this.postalAddress,
      ContactProvided: []
    };
    contactInformation.ContactProvided.push({
      EmailAddress: {
        EmailAddressValue: 'ndc@ba.com'
      }
    });
    // if (paymentType === 'CARD')
    if (contactDetail.phone.e164Number) {
      contactInformation.ContactProvided.push({
        Phone: {
          Label: 'Home',
          CountryDialingCode: contactDetail.phoneCode,
          AreaCode: contactDetail.phoneCode,
          PhoneNumber: contactDetail.phone.e164Number.split('+')[1].replace('/s/g', '')
        }
      });
    }

    if (!customerType) {
      delete contactInformation.ContactType;
    }
    contactInformationList.push(contactInformation);
    if (paymentType === 'CARD' && !customerType) {
      let contactInformation2: orderChangeIssueTicketContactInformation = {
        $: {
          ContactID: 'pcontact-1'
        },
        ContactType: 'Payment',
        PostalAddress: {
          Street: [customerDetail.address1, customerDetail.address2],
          PostalCode: customerDetail.zipCode,
          CityName: customerDetail.city,
          CountryCode: 'GB'
        },
        ContactProvided: [],
        Individual: {
          NameTitle: this.capitalizeFirstLetter(passengerDetail[0].passengerNameTitle),
          GivenName: customerDetail.firstName,
          Surname: customerDetail.lastName
        }
      };
      contactInformation2.ContactProvided.push({
        EmailAddress: {
          EmailAddressValue: 'ndc@ba.com'
        }
      });

      if (contactDetail.phone.e164Number) {
        contactInformation2.ContactProvided.push({
          Phone: {
            Label: 'Home',
            CountryDialingCode: contactDetail.phoneCode,
            AreaCode: contactDetail.phoneCode,
            PhoneNumber: contactDetail.phone.e164Number.split('+')[1].replace('/s/g', '')
          }
        });
      }

      contactInformationList.push(contactInformation2);
    }

    if (
      this.confirmBookingScreenData.bookingType === 'post-booking-issue-ticket-form' ||
      this.confirmBookingScreenData.bookingType === 'post-booking-paid-sale-seat-form' ||
      this.confirmBookingScreenData.bookingType === 'post-booking-add-paid-ancilliaries-service'
    ) {
      this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList = {
        ContactInformation: contactInformationList
      };
    }
    if (this.confirmBookingScreenData.bookingType === 'pre-booking-form') {
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.ContactList.ContactInformation = contactInformationList;
    }
    if (paymentType === 'CARD' && (this.confirmBookingScreenData.bookingType === 'post-booking-reshop' || this.confirmBookingScreenData.bookingType === 'post-booking-reshop-hold')) {
      this.orderChangeChangeDateTime['S:Envelope']['S:Body']!.OrderChangeRQ.DataLists.ContactList = {
        ContactInformation: contactInformationList
      };
    }
  }

  async initReQuoteHeldBookingRequest() {
    let yourBookingScreenDetail = this.sandboxPageStateService.getYourBookingScreenData();
    let bookingDetail = yourBookingScreenDetail.booking;
    let pnr = bookingDetail?.pnrNumber;
    let owner = bookingDetail?.bookingAgent;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCHANGE_REQUOTE_TICKET_REQUEST_TEMPLATE);
    this.orderChangeRequoteHeldBooking = JSON.parse(jsonRequestTemplate as any);
    this.orderChangeRequoteHeldBooking['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRequoteHeldBooking['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
    this.orderChangeRequoteHeldBooking['S:Envelope']['SOAP-ENV:Header'] = '';
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body']!.OrderChangeRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body']!.OrderChangeRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body']!.OrderChangeRQ.$.Version = '17.2';

    //this.orderChangeRequoteTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = [];
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ.DataLists = {
      PassengerList: {
        Passenger: []
      },
      ContactList: {
        ContactInformation: {
          $: {
            ContactID: ''
          },
          PostalAddress: {
            Label: 'Address'
          },
          ContactProvided: {
            EmailAddress: {
              EmailAddressValue: this.inp_group_control('contactDetail', 'email').value
            }
          }
        }
      }
    };
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID._ = pnr;
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ.Query.OrderID.$.Owner = owner;
    this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ.Query.AcceptRepricedOrder.ResponseID = this.confirmBookingScreenData.heldBookingReQuoteTicketDetails?.ResponseID;
    this.loadPassengerDetail();
    //this.orderChangeRequoteTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.ContactProvided.EmailAddress.EmailAddressValue =

    await this.apiService.getXMLResponse(this.sandboxPageStateService.REQUOTE_HELD_ORDER_CHANGE_URL, JSON.stringify(this.orderChangeRequoteHeldBooking), this.reQuoteTicketInputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'OrderChange17_2_V4'
      }),
      responseType: 'text'
    });
    this.updateReQuoteHeldTicketXML(this.sandboxPageStateService.REQUOTE_HELD_ORDER_CHANGE_URL);
  }

  updateReQuoteHeldTicketXML(url: any) {
    let reQuoteIssueTicketXMLData = this.sandboxPageStateService.getResponseFromMap(url);
    let reQuoteIssueTicketJSONData = this.xmlToJsonParserService.parseXMLToJSON(reQuoteIssueTicketXMLData);

    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      patchSandboxSourceData = { mainMenu: 'none' };
      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }

      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

      let yourBookingScreenData = this.sandboxPageStateService.getYourBookingScreenData();
      yourBookingScreenData.xml = reQuoteIssueTicketXMLData;
      yourBookingScreenData.jsonData = reQuoteIssueTicketJSONData;
      yourBookingScreenData.isMapped = false;
      yourBookingScreenData.displayConfirmBookingForm = false;
      yourBookingScreenData.displayCancelGetRefundForm = false;
      yourBookingScreenData.selectedSeatItem = [];
      // yourBookingScreenData.booking = {} as Booking;
      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreenData);

      setTimeout(() => {
        patchSandboxSourceData = { mainMenu: 'your-booking-screen' };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }, 200);
    }
  }

  loadPassengerBasicRequestXMLDetailDetail() {
    let passengerDetails: confirmBookingPassenger[] = [];
    let passengerDetailLength: any = this.passengerDetail?.length;
    if (passengerDetailLength > 0) {
      this.passengerDetail?.forEach((passenger: PassengerDetailSceenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as confirmBookingPassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        passengerDetail.Birthdate = passenger.passengerDOB;
        passengerDetail.Individual = {
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        if (typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }
        passengerDetails.push(passengerDetail);
      });
    }
    return passengerDetails;
  }

  loadReshopPassengerDetail(paymentType: any) {
    let selectedPasengerIndex: any = 0;
    let customerType = this.inp_group_control('customerDetail', 'customerType').value;
    let customerDetail = this.inp_control('customerDetail').value;
    if (customerType) {
      selectedPasengerIndex = customerDetail.user;
    }
    let passengerDetails: ReshopPassenger[] = [];

    let passengerDetailLength: any = this.passengerDetail?.length;
    if (passengerDetailLength > 0) {
      let passengerIndex: any = 0;
      this.passengerDetail?.forEach((passenger: PassengerDetailSceenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as ReshopPassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        // if (typeof passenger.residenceCountryCode !== 'undefined') {
        //   passengerDetail.ResidenceCountryCode = passenger.residenceCountryCode;
        // }
        // if (typeof passenger.cityzenShipCode !== 'undefined') {
        //   passengerDetail.CitizenshipCountryCode = passenger.cityzenShipCode;
        // }
        passengerDetail.Individual = {
          Birthdate: passenger.passengerDOB,
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        if (passenger.loyaltyProgramNumber) {
          passengerDetail.LoyaltyProgramAccount = {
            Airline: {
              AirlineDesignator: 'BA'
            },
            ProgramName: passenger.loyaltyProgram,
            AccountNumber: passenger.loyaltyProgramNumber
          };
          // if(typeof passengerDetail.LoyaltyProgramAccount.ProgramName === 'undefined' || passengerDetail.LoyaltyProgramAccount.ProgramName === '') {
          delete passengerDetail.LoyaltyProgramAccount.ProgramName;
          // }
        }
        if (passenger.idnumber) {
          passengerDetail.IdentityDocument = [
            {
              IdentityDocumentNumber: passenger.idnumber,
              IdentityDocumentType: passenger.identity,
              IssuingCountryCode: passenger.issuingCountry,
              CitizenshipCountryCode: passenger.cityzenShipCode,

              ExpiryDate: passenger.expiryDate,
              Birthdate: passenger.passengerDOB,
              Gender: passenger.passengerGender
            }
          ];

          if (passenger.redressNumber !== '' && passenger.redressNumber !== null && typeof passenger.redressNumber !== 'undefined') {
            passengerDetail.IdentityDocument.push({
              IdentityDocumentNumber: passenger.redressNumber,
              IdentityDocumentType: 'AEA',
              IssuingCountryCode: passenger.issuingCountry
            });
          }
        }
        if (paymentType === 'CARD' && passengerIndex.toString() === selectedPasengerIndex.toString()) {
          passengerDetail.ContactInfoRef = 'contact-' + passengerId;
        }
        if (paymentType === 'CARD' && typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }
        passengerDetails.push(passengerDetail);
        passengerIndex++;
      });
      this.orderChangeChangeDateTime['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
    }
  }
  loadPassengerDetail() {
    let selectedPasengerIndex: any = 0;
    let customerType = this.inp_group_control('customerDetail', 'customerType').value;
    let customerDetail = this.inp_control('customerDetail').value;
    if (customerType) {
      selectedPasengerIndex = customerDetail.user;
    }
    let passengerDetails: confirmBookingPassenger[] = [];

    let passengerDetailLength: any = this.passengerDetail?.length;
    if (passengerDetailLength > 0) {
      let passengerIndex: any = 0;
      this.passengerDetail?.forEach((passenger: PassengerDetailSceenPassenger) => {
        let passengerId = passenger.passengerId;
        let passengerDetail = {} as confirmBookingPassenger;
        passengerDetail.$ = {
          PassengerID: passengerId
        };
        passengerDetail.PTC = passenger.passengerType;
        passengerDetail.Birthdate = passenger.passengerDOB;
        if (typeof passenger.residenceCountryCode !== 'undefined') {
          passengerDetail.ResidenceCountryCode = passenger.residenceCountryCode;
        }
        if (typeof passenger.cityzenShipCode !== 'undefined') {
          passengerDetail.CitizenshipCountryCode = passenger.cityzenShipCode;
        }
        passengerDetail.Individual = {
          Gender: passenger.passengerGender,
          NameTitle: this.capitalizeFirstLetter(passenger.passengerNameTitle),
          GivenName: passenger.passengerName,
          Surname: passenger.passengerSurName
        };
        if (passenger.loyaltyProgramNumber) {
          passengerDetail.LoyaltyProgramAccount = {
            Airline: {
              AirlineDesignator: 'BA'
            },
            ProgramName: passenger.loyaltyProgram,
            AccountNumber: passenger.loyaltyProgramNumber
          };
          // if(passengerDetail.LoyaltyProgramAccount.ProgramName === '') {
          delete passengerDetail.LoyaltyProgramAccount.ProgramName;
          // }
        }
        if (passenger.idnumber) {
          passengerDetail.IdentityDocument = [
            {
              IdentityDocumentNumber: passenger.idnumber,
              IdentityDocumentType: passenger.identity,
              IssuingCountryCode: passenger.issuingCountry,
              CitizenshipCountryCode: passenger.cityzenShipCode,
              ResidenceCountryCode: passenger.nationalities,
              ExpiryDate: passenger.expiryDate,
              Birthdate: passenger.passengerDOB,
              Gender: passenger.passengerGender
            }
          ];
          if (passenger.redressNumber !== '' && passenger.redressNumber !== null && typeof passenger.redressNumber !== 'undefined') {
            passengerDetail.IdentityDocument.push({
              IdentityDocumentNumber: passenger.redressNumber,
              IdentityDocumentType: 'AEA',
              IssuingCountryCode: passenger.issuingCountry
            });
          }
        }

        if (passengerIndex.toString() === selectedPasengerIndex.toString()) {
          passengerDetail.ContactInfoRef = 'contact-' + passengerId;
        }
        if (typeof passenger.infantRef !== 'undefined') {
          passengerDetail.InfantRef = passenger.infantRef;
        }

        if (passenger.enableAddressDetail) {
          if (passenger.zip && passenger.city && passenger.country && passenger.address1 && passenger.address2) {
            this.postalAddress = {
              Label: 'AddressAtDestination',
              Street: [passenger.address1, passenger.address2],
              PostalCode: passenger.zip,
              CityName: passenger.city,
              CountryCode: passenger.country
            };
          }
        }

        passengerDetails.push(passengerDetail);
        passengerIndex++;
      });

      if (this.confirmBookingScreenData.bookingType === 'post-booking-requote-ticket-form') {
        this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.ContactList.ContactInformation.$.ContactID =
          'contact-' + passengerDetails[selectedPasengerIndex].$.PassengerID;
      }

      if (this.confirmBookingScreenData.bookingType === 'post-booking-requote-ticket-form') {
        this.orderChangeRequoteHeldBooking['S:Envelope']['S:Body'].OrderChangeRQ['DataLists']['PassengerList']['Passenger'] = passengerDetails;
      }
      if (this.confirmBookingScreenData.bookingType === 'pre-booking-form') {
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.PassengerList.Passenger = passengerDetails;
      }
      if (this.confirmBookingScreenData.bookingType === 'post-booking-issue-ticket-form') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
      }
      if (this.confirmBookingScreenData.bookingType === 'post-booking-paid-sale-seat-form') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
      }
      if (this.confirmBookingScreenData.bookingType === 'post-booking-add-paid-ancilliaries-service') {
        this.orderChangeIssueTicket['S:Envelope']['S:Body'].OrderChangeRQ.DataLists.PassengerList.Passenger = passengerDetails;
      }
    }
  }
  // orderChangeRequoteTicket
  capitalizeFirstLetter(words: any) {
    const result = words.charAt(0).toUpperCase() + words.slice(1).toLowerCase();
    return result;
  }

  loadOrderCreateOfferPrice(offerItemsList: OfferItems[]) {
    let offerItems: OfferItemOrderCreate[] = [];
    offerItemsList.forEach((offer: OfferItems) => {
      let offerItem = {} as OfferItemOrderCreate;
      offerItem.PassengerRefs = offer.passengerRefs;
      offerItem.$ = {} as OfferItemIDAttributesOrderCreate;
      offerItem.$.OfferItemID = offer.offerItemID;
      offerItems.push(offerItem);
    });
    return offerItems;
  }

  loadBaggageOfferPrice(baggageItemsList: SelectedBaggageDetail[]) {
    let offerItems: OfferItemOrderCreate[] = [];
    baggageItemsList.forEach((baggage: SelectedBaggageDetail) => {
      let offerItem = {} as OfferItemOrderCreate;
      offerItem.PassengerRefs = baggage.passengerId;
      offerItem.$ = {} as OfferItemIDAttributesOrderCreate;
      offerItem.$.OfferItemID = baggage.OfferItemID;
      offerItems.push(offerItem);
    });
    return offerItems;
  }

  loadSeatOfferPrice(seatList: SelectedSeatDetail[]) {
    let offerItems: OfferItemOrderCreate[] = [];
    seatList.forEach((seat: SelectedSeatDetail) => {
      let offerItem = {} as OfferItemOrderCreate;
      offerItem.$ = {} as OfferItemIDAttributesOrderCreate;
      offerItem.$.OfferItemID = seat.offerItemID;
      offerItem.PassengerRefs = seat.passengerId;
      let seatLayout = {} as SeatSelection;
      seatLayout.Row = seat.seatDetail.row;
      seatLayout.Column = seat.seatDetail.column;
      offerItem.SeatSelection = seatLayout;
      offerItems.push(offerItem);
    });
    return offerItems;
  }

  async initOfferPriceScreenPrimeOrderCreateBooking() {
    let searchFlightFormValue = this.sandboxPageStateService.getSearchFlightFormValue();
    let isShortSell = searchFlightFormValue.shortSell;
    let paymentType = this.inp_group('paymentType').value;
    if (paymentType != '') {
      let offerPriceScreenDetail = this.sandboxPageStateService.getOfferPriceScreenData();

      let offerPrice = offerPriceScreenDetail.offerPrice;
      let boundOffers = offerPriceScreenDetail.offerPrice.boundAirlineOffer;
      let responseId = offerPriceScreenDetail.offerPrice.responseId;
      let owner = offerPriceScreenDetail.offerPrice.owner;
      let offerId = offerPriceScreenDetail.offerPrice.offerId;
      let selectedOfferItem = offerPriceScreenDetail.selectedOfferItem;
      let selectedBagOfferItem = this.offerPriceScreebData.selectedBagOfferItem;
      let selectedSeats = this.offerPriceScreebData.selectedSeatItem;
      const jsonRequest = this.sandboxPageStateService.getJsonRequestFromMap(this.sandboxPageStateService.AIRLINE_OFFERS_SCREEN_URL);
      const airlineOffersScreenRequest: AirlineOffersScreenRequest = JSON.parse(jsonRequest);
      // airlineOffersScreenRequest["S:Envelope"]["S:Body"]?.OfferPriceRQ.Party?.Sender.TravelAgencySender.Type='Online';
      let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.ORDERCREATE_REQUEST_TEMPLATE);
      this.offerPriceScreenOrderCreateRequest = JSON.parse(jsonRequestTemplate as any);
      this.offerPriceScreenOrderCreateRequest['S:Envelope'].$['xmlns:S'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.offerPriceScreenOrderCreateRequest['S:Envelope'].$['xmlns:SOAP-ENV'] = 'http://schemas.xmlsoap.org/soap/envelope/';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['SOAP-ENV:Header'] = '';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.$['xmlns:xsd'] = 'http://www.w3.org/2001/XMLSchema';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.$['xmlns:xsi'] = 'http://www.w3.org/2001/XMLSchema-instance';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.$.xmlns = 'http://www.iata.org/IATA/EDIST/2017.2';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.$.Version = '17.2';
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Document = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Document;
      // this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Party = airlineOffersScreenRequest['S:Envelope']['S:Body']?.OfferPriceRQ.Party;
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Party = this.getPrimeSalePartyDetail();
      this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.PassengerList.Passenger = [];
      this.loadPassengerDetail();
      if (isShortSell) {
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order = {
          Offer: []
        };
        let offer: OfferOrderCreate = {
          $: {
            OfferID: offerId,
            Owner: owner,
            ResponseID: responseId
          },
          OfferItem: this.loadOrderCreateOfferPrice(selectedOfferItem)
        };
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.Offer?.push(offer);
        if (selectedBagOfferItem && selectedBagOfferItem.offerDetail && selectedBagOfferItem.offerDetail.length) {
          let baggageOffer: OfferOrderCreate = {
            $: {
              OfferID: selectedBagOfferItem.offerId,
              Owner: selectedBagOfferItem.owner,
              ResponseID: selectedBagOfferItem.responseId
            },
            OfferItem: this.loadBaggageOfferPrice(selectedBagOfferItem.offerDetail)
          };
          this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.Offer?.push(baggageOffer);
        }
        if (selectedSeats && selectedSeats.length > 0) {
          let seatOfferList: OfferOrderCreate[];
          selectedSeats.forEach((seatOffers: PassengerSelectedSeatDetail) => {
            let seatOffer: OfferOrderCreate = {
              $: {
                OfferID: seatOffers.offerId,
                Owner: seatOffers.owner,
                ResponseID: seatOffers.responseId
              },
              OfferItem: this.loadSeatOfferPrice(seatOffers.offerDetail)
            };
            this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.Offer?.push(seatOffer);
          });
        }
      } else {
        delete this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.Offer;
        this.usedSegmentKey = [];
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order = {
          OrderItem: this.loadLongSellOrderItems(boundOffers, owner)
        };
        //remove unwanted segment key
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Order.OrderItem?.forEach((loadOrderItem: OrderItem) => {
          if (typeof loadOrderItem.OfferItemType.DetailedFlightItem !== 'undefined') {
            loadOrderItem.OfferItemType.DetailedFlightItem.OriginDestination[0].Flight.forEach((flightDetail: Flight) => {
              let segmentKeyIsUsedForService = this.usedSegmentKey.indexOf(flightDetail.SegmentKey);
              if (segmentKeyIsUsedForService === -1) {
                delete flightDetail.SegmentKey;
              }
            });
          }
        });
        //end
      }

      if (paymentType === 'HOLD') {
        delete this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments;
      } else if (paymentType === 'CASH') {
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments = {} as confirmBookingPayments;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        delete this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.Cash = {} as confirmBookingCash;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.Cash.$ = {} as confirmBookingCashAttributes;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Amount = {} as confirmBookingAmount;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Amount.$ = {} as confirmBookingAmountAttributes;

        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = this.getCashBookingPaymentDetail();
      } else if (paymentType === 'CARD') {
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments = {} as confirmBookingPayments;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        delete this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = {} as confirmBookingPayment;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method = {} as confirmBookingMethod;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.PaymentCard = {} as confirmBookingPaymentCard;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Payer = {} as confirmBookingPayer;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.PaymentCard.CardHolderBillingAddress =
          {} as confirmBookingCardHolderBillingAddress;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.PaymentCard.EffectiveExpireDate = {} as confirmBookingEffectiveExpireDate;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment.Method.PaymentCard.Surcharge = {} as confirmBookingSurcharge;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.Payments.Payment = this.getCardBookingPaymentDetail();
      }
      if (paymentType === 'HOLD') {
        this.loadContactDetail('HOLD');
      } else if (paymentType === 'CASH') {
        this.loadContactDetail('CASH');
      } else if (paymentType === 'CARD') {
        this.loadContactDetail('CARD');
      }
      if (!isShortSell) {
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.FareList = {} as FareList;
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.FareList.FareGroup = [];
        this.offerPriceScreenOrderCreateRequest['S:Envelope']['S:Body']!.OrderCreateRQ.Query.DataLists.FareList.FareGroup = this.loadFareGroupLongSell();
      }
      await this.apiService.getXMLResponse(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL, JSON.stringify(this.offerPriceScreenOrderCreateRequest), this.orderCreateParamsMap, {
        headers: new HttpHeaders({
          soapAction: 'OrderCreate17_2_V5'
        }),
        responseType: 'text'
      });
      this.updateYourBookingScreenXML(this.sandboxPageStateService.OFFER_PRICE_SCREEN_ORDER_CREATE_URL);
    }
  }
  getPrimeSalePartyDetail() {
    let primeSalePartyDetail: OrderCreateParty = {
      Sender: {
        TravelAgencySender: {
          Type: '##TravelAgencySender##Type##',
          Contacts: {
            Contact: {
              AddressContact: {
                Street: ['##AddressContact##Street1##', '##AddressContact##Street2##'],
                CityName: '##AddressContact##CityName##',
                PostalCode: '##AddressContact##PostalCode##',
                CountryCode: '##AddressContact##CountryCode##'
              },
              EmailContact: {
                Address: '##EmailContact##Address##'
              }
            }
          },
          IATA_Number: '##IATA_Number##',
          AgencyID: '##AgencyID##'
        }
      },
      Participants: {
        Participant: {
          AggregatorParticipant: {
            $: {
              SequenceNumber: '1'
            },
            Name: '##AggregatorParticipant##Name##',
            AggregatorID: '##AggregatorParticipant##AggregatorID##'
          }
        }
      },
      Recipient: {
        $: {
          'xsi:nil': 'true'
        }
      }
    };
    return primeSalePartyDetail;
  }
  loadLongSellOrderItems(boundOffers: BoundAirlineOffer[], owner: any) {
    let orderItems: OrderItem[] = [];
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let passengerIndex: any = 1;
    passengerDetail.forEach((passenger: PassengerDetailSceenPassenger) => {
      let passengerId = passenger.passengerId;
      let fbCode: any = '';
      if (passenger.passengerId === passengerId) {
        this.loadFareGroupLongSell().forEach((fareGroup) => {
          if (fareGroup.$.ListKey.includes(passenger.passengerType)) {
            fbCode = fareGroup.$.ListKey;
          }
        });
      }

      let orderItem: OrderItem = {
        OfferItemID: {
          $: {
            Owner: owner
          },
          _: passengerIndex
        },
        OfferItemType: {
          DetailedFlightItem: {
            $: {
              refs: passengerId
            },
            Price: {
              BaseAmount: {
                $: {
                  Code: passenger.currency
                },
                _: passenger.basePrice
              },
              Taxes: {
                Total: {
                  $: {
                    Code: passenger.currency
                  },
                  _: passenger.taxPrice
                }
              }
            },
            OriginDestination: this.loadOfferPriceRequestOrigin(boundOffers, fbCode)
          }
        }
      };
      passengerIndex++;
      orderItems.push(orderItem);
    });
    let offerPriceScreenData = this.sandboxPageStateService.getOfferPriceScreenData();
    let selectedSeats = offerPriceScreenData.selectedSeatItem;
    if (selectedSeats && selectedSeats.length > 0) {
      selectedSeats.forEach((seatOffers: PassengerSelectedSeatDetail) => {
        let offerDetails = seatOffers.offerDetail;
        let offerDetailsLength = offerDetails.length;
        if (offerDetailsLength > 0) {
          let segmentKey = boundOffers[seatOffers.boundOfferIndex].flightDetails[seatOffers.flightIndex].segmentKey;
          this.usedSegmentKey.push(segmentKey);
          offerDetails.forEach((offerDetail: SelectedSeatDetail) => {
            let passengerId = offerDetail.passengerId;
            let orderItem: OrderItem = {
              OfferItemID: {
                $: {
                  Owner: owner
                },
                _: passengerIndex
              },
              OfferItemType: {
                SeatItem: {
                  $: {
                    refs: passengerId + ' ' + segmentKey
                  },
                  Price: {
                    Total: {
                      SimpleCurrencyPrice: {
                        $: {
                          Code: offerDetail.currency
                        },
                        _: offerDetail.price
                      }
                    }
                  },
                  Descriptions: this.loadLongSellSeatDescription(offerDetail.descriptions[0].DESCRIPTION),
                  Location: {
                    Column: offerDetail.seatDetail.column,
                    Row: {
                      Number: offerDetail.seatDetail.row
                    }
                  }
                }
              }
            };
            orderItems.push(orderItem);
            passengerIndex++;
          });
        }
      });
    }
    let selectedBags = offerPriceScreenData.selectedBagOfferItem.offerDetail;
    if (selectedBags && selectedBags.length > 0) {
      selectedBags.forEach((selectedBag: SelectedBaggageDetail) => {
        let passengerId = selectedBag.passengerId;
        let flightDetailIndex: any = this.flightSegmentNumberIds.indexOf(selectedBag.flightSegmentNumber);
        let bagCount = '1';
        if (flightDetailIndex === -1) {
          flightDetailIndex = this.flightSegmentNumberIds.indexOf(selectedBag.flightSegmentNumber.split(' ')[0]);
          bagCount = selectedBag.flightSegmentNumber.split(' ').length;
        }
        if (flightDetailIndex !== -1) {
          let segmentKey = this.flightDetails[flightDetailIndex].SegmentKey;
          this.usedSegmentKey.push(segmentKey);
          let orderItem: OrderItem = {
            OfferItemID: {
              $: {
                Owner: owner
              },
              _: passengerIndex
            },
            OfferItemType: {
              BaggageItem: {
                $: {
                  refs: passengerId + ' ' + segmentKey
                },
                Price: {
                  Total: {
                    SimpleCurrencyPrice: {
                      $: {
                        Code: selectedBag.currency
                      },
                      _: selectedBag.price
                    }
                  }
                },
                BagDetails: [
                  {
                    BagDetail: {
                      ValidatingCarrier: owner,
                      CheckedBags: [
                        {
                          CheckedBag: {
                            PieceAllowance: {
                              ApplicableParty: 'Party',
                              TotalQuantity: bagCount,
                              PieceMeasurements: {
                                $: {
                                  Quantity: bagCount
                                }
                              }
                            }
                          }
                        }
                      ]
                    }
                  }
                ]
              }
            }
          };
          orderItems.push(orderItem);
          passengerIndex++;
        }
      });
    }
    return orderItems;
  }
  loadLongSellSeatDescription(descriptions: any[]) {
    let descriptionLength = descriptions.length;
    let seatDescriptions: SeatDescriptions[] = [];
    if (descriptionLength > 0) {
      descriptions.forEach((description: any) => {
        let seatDescription: SeatDescriptions = {
          Description: {
            Text: description.TEXT[0]
          }
        };
        seatDescriptions.push(seatDescription);
      });
    }
    return seatDescriptions;
  }
  loadOfferPriceRequestOrigin(boundOffers: BoundAirlineOffer[], fbCode: any) {
    let originDestination: OriginDestination[] = [];
    let boundOffersLength = boundOffers.length;
    if (boundOffersLength > 0) {
      let flightsDetail: Flight[] = [];
      boundOffers.forEach((boundOffer: BoundAirlineOffer) => {
        boundOffer.flightDetails.forEach((flightDetail: FlightDetail) => {
          let flightMapResult = this.mapOfferRequestFlightDetail(flightDetail, fbCode);
          flightsDetail.push(flightMapResult);
        });
      });
      originDestination.push({
        Flight: flightsDetail
      });
    }
    return originDestination;
  }
  mapOfferRequestFlightDetail(flightDetail: FlightDetail, fbCode: any) {
    let isAlreadyPushed: any = this.flightSegmentNumberIds.indexOf(flightDetail.airlineId + '' + flightDetail.airlineNumber);
    if (isAlreadyPushed === -1) {
      this.flightSegmentNumberIds.push(flightDetail.airlineId + '' + flightDetail.airlineNumber);
      this.flightDetails.push({
        SegmentKey: flightDetail.segmentKey,
        airlineCode: flightDetail.airlineId + '' + flightDetail.airlineNumber
      });
    }
    let mapFlightDetail: Flight = {
      SegmentKey: flightDetail.segmentKey,
      Departure: {
        AirportCode: flightDetail.departureAirportCode,
        Date: flightDetail.actualDepatureDate,
        Time: flightDetail.departureTimeIn24H
      },
      Arrival: {
        AirportCode: flightDetail.arrivalAirportCode,
        Date: flightDetail.actualArrivalDate
      },
      MarketingCarrier: {
        AirlineID: flightDetail.airlineId,
        FlightNumber: flightDetail.airlineNumber
      },
      ClassOfService: {
        $: {
          refs: fbCode
        },
        Code: flightDetail.economyCode
      }
    };
    let offerPriceScreenData = this.sandboxPageStateService.getOfferPriceScreenData();
    let selectedSeats = offerPriceScreenData.selectedSeatItem;
    let selectedBags = offerPriceScreenData.selectedBagOfferItem;
    if (selectedSeats.length === 0 && selectedBags.offerDetail.length === 0) {
      delete mapFlightDetail.SegmentKey;
    }
    return mapFlightDetail;
  }
  loadFareGroupLongSell(): FareGroup[] {
    let fareGroupList: FareGroup[] = [];
    let listKey: string = '';
    const longsellData = this.confirmBookingScreenData.longsellDetails;
    longsellData?.fareList.forEach((fare: any) => {
      let ref = fare.$.REFS;
      let refArr: any[] = [];
      refArr = ref.split(' ');
      let ptc: any;
      this.passengerDetail.filter((passenger: any) => {
        refArr.forEach((reference: any) => {
          if (passenger.passengerId === reference) {
            ptc = passenger.passengerType;
          }
        });
      });
      listKey = fare.$.LISTKEY + ptc;
      fareGroupList.push({
        $: {
          ListKey: listKey
        },
        Fare: {
          FareCode: fare.FARE[0].FARECODE[0]
        },
        FareBasisCode: {
          Code: fare.FAREBASISCODE[0].CODE[0]
        }
      });
    });
    return fareGroupList;
  }

  mapFareGroup(flightDetail: FlightDetail) {
    let isCodeMapped: any = this.mappedSelectedOfferPriceFareCode.indexOf(flightDetail.fbcode);

    let fareFroupData = { isMapped: false, fareGroup: {} as FareGroup };
    if (isCodeMapped === -1) {
      this.mappedSelectedOfferPriceFareCode.push(flightDetail.fbcode);
      let fareGroup: FareGroup = {
        $: {
          ListKey: flightDetail.fbcode
        },
        Fare: {
          FareCode: flightDetail.fareCode
        },
        FareBasisCode: {
          Code: flightDetail.priceClassCode
        }
      };
      fareFroupData.isMapped = true;
      fareFroupData.fareGroup = fareGroup;
    }
    return fareFroupData;
  }
  updateYourBookingScreenXML(url: string) {
    let patchSandboxSourceData: any = '';
    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      this.submitted = false;
      patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    } else {
      let yourBookingScreen: YourBookingScreen = {} as YourBookingScreen;
      yourBookingScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);
      yourBookingScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(yourBookingScreen.xml!);
      yourBookingScreen.bookingType = 'pre-booking';
      yourBookingScreen.actualBookingType = 'pre-booking';
      yourBookingScreen.displayConfirmBookingForm = false;

      this.sandboxPageStateService.updateYourBookingScreenData(yourBookingScreen);

      let addAnclilliariesScreenData = {} as AddAncilliariesScreen;
      this.sandboxPageStateService.updateAddAncilliariesScreenData(addAnclilliariesScreenData);

      this.sandboxPageStateService.widthChange70();
      patchSandboxSourceData = { mainMenu: 'your-booking-screen' };

      if (this.sandboxPageStateService.getWarningMessage() !== '') {
        patchSandboxSourceData['showWarning'] = 'Yes';
        patchSandboxSourceData['warningMessage'] = this.sandboxPageStateService.getWarningMessage();
      }
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  getCashBookingPaymentDetail() {
    return {
      Type: 'CA',
      Method: {
        Cash: {
          $: {
            CashInd: 'true'
          }
        }
      },
      Amount: {
        $: {
          Code: this.priceDetails.currency
        },
        _: this.priceDetails.totalPrice
      }
    };
  }

  getCardBookingPaymentDetail() {
    let passengerScreenDetail = this.sandboxPageStateService.getPassengerScreenDetail();
    let passengerDetail = passengerScreenDetail.passengerDetail;
    let customerDetail = this.inp_control('customerDetail').value;
    let holderName: any = this.capitalizeFirstLetter(passengerDetail[0].passengerNameTitle) + ' ' + customerDetail.firstName + ' ' + customerDetail.lastName;
    let customerType = this.inp_group_control('customerDetail', 'customerType').value;

    if (customerType) {
      holderName = {
        $: {
          refs: passengerDetail[customerDetail.user].passengerId
        },
        _: ' '
      };
    }

    let cardDetail: any = {
      Type: 'CC',
      Method: {
        PaymentCard: {
          CardType: this.selectedCardType,
          CardCode: this.selectedCardCode,
          CardNumber: this.selectedCardNumber,
          SeriesCode: this.inp_group_control('cardDetail', 'cv').value,
          CardHolderName: holderName,
          CardHolderBillingAddress: {
            Street: [customerDetail.address1, customerDetail.address2],
            CityName: customerDetail.city,
            StateProv: customerDetail.state,
            PostalCode: customerDetail.zipCode,
            CountryCode: this.countryCode
          },
          Surcharge: {
            Amount: {
              $: {
                Code: this.inp_group_control('priceDetail', 'currency').value
              },
              _: this.selectedCardSurcharge
            }
          },
          EffectiveExpireDate: {
            Expiration: this.inp_group_control('cardDetail', 'validMM').value + '' + this.inp_group_control('cardDetail', 'validYY').value
          }
        }
      },
      Amount: {
        $: {
          Code: this.priceDetails.currency
        },
        _: (+this.priceDetails.totalPrice + +this.selectedCardSurcharge).toFixed(2)
      }
    };
    if (!customerType) {
      cardDetail.Payer = {
        ContactInfoRefs: 'pcontact-1'
      };
    }

    return cardDetail;
  }

  getCardsNumbers() {
    this.activeCardDetilIndex = this.inp_group_control('cardDetail', 'cardType').value;
    const selectedCardName = this.paymentDetails.at(this.activeCardDetilIndex)?.CARDNAME[0];
    const selectedCardType=this.paymentDetails.at(this.activeCardDetilIndex)?.CARDTYPE[0];
    let selectedCardDetail: any = this.availableCards[this.activeCardDetilIndex];
    const cardDetail = this.cardDetails.find((cardDetail) => cardDetail.cardTypeName.toLowerCase() === selectedCardName.toLowerCase().split(' - ')[0] &&
      cardDetail.cardNumbersWithCategory.some((cardNumberWithCategory) =>
      cardNumberWithCategory.cardType.toLowerCase() === selectedCardType?.toLowerCase()
    ));
    this.cardNumberDetails = cardDetail ? cardDetail.cardNumbersWithCategory.filter((cardNumberWithCategory) => cardNumberWithCategory.category === this.countryCode) : [];
    try {
      // this.selectedCardSurcharge = this.paymentDetails.at(this.activeCardDetilIndex)?.SURCHARGE[0]?.AMOUNT[0]?._ || 0;
      this.selectedCardSurcharge = selectedCardDetail.surcharge;
    } catch {
      this.selectedCardSurcharge = 0;
    }

    if (selectedCardName === 'American Express' || selectedCardName === 'American Express Consumer' || selectedCardName === 'American Express Corporate') {
      this.paymentForm.controls.cardDetail.controls.cv.setValue('7777');
    } else {
      this.paymentForm.controls.cardDetail.controls.cv.setValue('777');
    }
  }

  storeSelectedCardDetail() {
    const selectedCardIndex = this.inp_group_control('cardDetail', 'cardNumber').value;
    const selectedCardNumber = this.inp_group_control('cardDetail', 'cardNumber').value;
    const selectedCard = this.cardNumberDetails.find(c => c.cardNumber === selectedCardNumber);
  
    this.selectedCardType = selectedCard.cardType;
    this.selectedCardCode = selectedCard.cardCode;
    this.selectedCardNumber = selectedCard.cardNumber;
    
    ['##CardCode##', '##CardNumberToken##', '##Expiry##', '##CVV##'].forEach(k =>
      this.orderCreateParamsMap.delete(k)
    );
  
    this.orderCreateParamsMap.set('##CardCode##', selectedCard.cardCode);
    this.orderCreateParamsMap.set('##CardNumberToken##', selectedCard.cardNumber); 
    this.orderCreateParamsMap.set('##Expiry##', `${selectedCard.validMM}/${selectedCard.validYY}`);
    this.orderCreateParamsMap.set('##CVV##', selectedCard.cv); 
    }
  
  ngAfterViewChecked() {
    let sandboxData = this.sandboxPageStateService.getSandboxPage();
    if (sandboxData.isUpsellOfferSelected) {
      this.initPayment();
      sandboxData.isUpsellOfferSelected = false;
      this.sandboxPageStateService.updateSandboxPage(sandboxData);
      this.changeDetectionRef.detectChanges();
    }
  }
}
